import { enumParser } from '#validation/common/parsers';
import { SsoJoinStatus } from '../constants/sso-join-status';
export const ssoJoinStatusParser = enumParser(SsoJoinStatus);
